import axios from 'axios';

const config = {
  baseURL: process.env.REACT_APP_BASEURL_BACK,
  timeout: 240000,
};

const api = axios.create(config);

api.interceptors.request.use(async (config) => {
  const session = JSON.parse(localStorage.getItem('@EC-session'));

  if (!config.headers.Authorization || config.headers.Authorization && session.token) {
    config.headers.Authorization = `Bearer ${session.token}`;
    return config;
  }

  return Promise.reject(
    {
      response: {
        status: 401,
        data: {
          error: 'unauthorized',
          error_description: 'Full authentication is required to access this resource'
        }
      }
    }
  );
}, err => {
  console.log(err)
  return Promise.reject(err);
});

api.interceptors.response.use(
  (response) => { return response; },
  (error) => {
    //No mostrar el modal cuando se visualiza el modal de OTP
    if(!error.response.data.errores.intentos && !error.response.data.errores.maximo) {
      window.scrollTo(0, 0);
      document.getElementById("TitleModalInfoErrors").innerHTML = error.response.data.errores.reduce((accumulator, curr) => accumulator + curr + ' \n ', '');
      document.getElementById("ContainerModalInfoErrors").style.opacity = '1';
      document.getElementById("ContainerModalInfoErrors").style.height = 'auto';
      document.getElementById("ContainerModalInfoErrors").style.overflow = '';
    }
      
    return Promise.reject(error);
  }
);

export default api;
